import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@src/auth/auth.guard.service';
import { ActivationComponent } from './activation/activation.component';
import { DashboardComponent } from '@src/base-components/dashboard/dashboard.component';
import { LoginComponent } from '@src/auth/login.component';
import { SalesComponent } from '@src/base-components/sales/sales.component';
import { SaleDetailsComponent } from '@src/base-components/sales/sale-details/sale-details.component';
import { ProfileComponent } from '@src/base-components/profile/profile.component';
import { UsersComponent } from '@src/base-components/users/users.component';
import { UserDetailsComponent } from '@src/base-components/users/user-details/user-details.component';
import { PageNotFoundComponent } from '@src/shared/page-notfound.component';
import { RetailersComponent } from '@src/base-components/retailers/retailers.component';
import { RetailerDetailsComponent } from '@src/base-components/retailers/retailer-details/retailer-details.component';
import { RetailerDetailsDashboardComponent } from '@src/base-components/retailers/retailer-details/retailer-details-dashboard/retailer-details-dashboard.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ManagementComponent } from '@src/base-components/management/management.component';
import { ImportedRetailersLogComponent } from '@src/base-components/management/imported-retailers/imported-retailers-log.component';
import { ImportedProductsLogComponent } from '@src/base-components/management/imported-products/imported-products-log.component';
import { RepairsComponent } from '@src/base-components/repairs/repairs.component';
import { CustomersComponent } from '@src/base-components/customers/customers.component';
import { CustomerDetailsComponent } from '@src/base-components/customers/customers-details/customer-details.component';
import { AssistanceComponent } from './assistance/assistance.component';
import { TermsComponent } from './terms/terms.component';
import { ExternalSearchTagComponent } from './external-search/external-search-tag.component';
import { HelpComponent } from './help/help.component';
import { InventoriesComponent } from '@src/base-components/inventories/inventories.component';
import { InventoryDetailsComponent } from '@src/base-components/inventories/inventory-details/inventory-details.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'help',
    component: HelpComponent
  },
 {
    path: 'AfterSalesService/CustomerWarranties',
    component: ExternalSearchTagComponent
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  }, {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard]
  }, {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: {
      accessRuleKey: 'dashboard'
    }
  }, {
    path: 'repairs',
    component: RepairsComponent,
    canActivate: [AuthGuard],
    data: {
      accessRuleKey: 'repair'
    }
  }, {
    path: 'activation',
    component: ActivationComponent,
    canActivate: [AuthGuard],
    data: {
      accessRuleKey: 'activation'
    }
  }, {
    path: 'sales',
    children: [
      {
        path: '',
        component: SalesComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'sales'
        }
      }, {
        path: ':id',
        component: SaleDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'sales-details'
        }
      }, {
        path: 'search/:id',
        component: SaleDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'sales-details'
        }
      }, {
        path: 'search/list/:searchTerm',
        component: SalesComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'sales-details'
        }
      }
    ]
  }, {
    path: 'users',
    children: [
      {
        path: '',
        component: UsersComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'users'
        }
      }, {
        path: ':id',
        component: UserDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'users'
        }
      }
    ]
  }, {
    path: 'retailers',
    children: [
      {
        path: '',
        component: RetailersComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'retailers'
        }
      }, {
        path: ':id',
        children: [
          {
            path: '',
            component: RetailerDetailsDashboardComponent,
            canActivate: [AuthGuard],
            data: {
              accessRuleKey: 'retailers'
            }
          },
          {
            path: 'details',
            component: RetailerDetailsComponent,
            canActivate: [AuthGuard],
            data: {
              accessRuleKey: 'retailers'
            }
          }
        ]
      }
    ]
  }, {
    path: 'retailer',
    children: [
      {
        path: '',
        component: RetailerDetailsDashboardComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'retailer'
        }
      },
      {
        path: 'details',
        component: RetailerDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'retailer'
        }
      }
    ]
  },
  {
    path: 'management',

    children: [{
      path: '',
      component: ManagementComponent,
      canActivate: [AuthGuard],
      data: {
        accessRuleKey: 'management'
      }
    },
    {
      path: 'retailerslogs/:id',
      component: ImportedRetailersLogComponent,
      canActivate: [AuthGuard],
      data: {
        accessRuleKey: 'management'
      }
    },
    {
      path: 'productslogs/:id',
      component: ImportedProductsLogComponent,
      canActivate: [AuthGuard],
      data: {
        accessRuleKey: 'management'
      }
    }
    ]
  },
 {
    path: 'customers',
    children: [
      {
        path: '',
        component: CustomersComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'customers'
        }
      }, {
        path: ':id',
        component: CustomerDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          accessRuleKey: 'customers'
      }
    }]
  },
  {
    path: 'inventories',
    children: [{
      path: '',
      component: InventoriesComponent,
      canActivate: [AuthGuard],
      data: {
        accessRuleKey: 'inventories',
      },
    },
    {
      path: ':id',
      component: InventoryDetailsComponent,
      canActivate: [AuthGuard],
      data: {
        accessRuleKey: 'inventories',
      }
    }]
  },
  {
    path: 'privacypolicy',
    component: PrivacyComponent
  },
  {
    path: 'assistance',
    component: AssistanceComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { enableTracing: false })]
})
export class TagRoutingModule { }